import {  SubmissionUpdateBody } from "../../../../page-controller-mod/page-serv/settings/general-set/ts/setting-submission.type";
import { SettingChange } from "./settings-draft.context";

export const buildSubmissionPayload = (changes: SettingChange[]): SubmissionUpdateBody => {
  const body: SubmissionUpdateBody = {};

  const ensure = {
    read: () => (body.read ??= {}),
  };

  for (const c of changes) {
    if (c.pageKey !== "submission") continue;
    if (c.type !== "toggle") continue;

    // Group 1 item 1 => read.autoMarkOnOpen
    if (c.groupId === 1 && c.itemId === 1) {
      ensure.read().autoMarkOnOpen = Boolean(c.value);
    }
  }

  return body;
};